"use strict";

module.exports = class CheckoutModel {

  request(bundleCode, promo, tariff, offerId) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      const url = bundleCode ? `${$BILLING}/bundles/${bundleCode}` : `${$BILLING}/tariffs/${offerId}`

      let query = promo ? `?promocode=${promo}` : "";

      if (tariff) {
        query += query.includes("?") ? "&" : "?";
        query += `tariff=${tariff}`;
      }

      xhr.open("GET", url + query, false);
      xhr.onreadystatechange = function() {
        if (xhr.status === 200) {
          resolve(JSON.parse(xhr.responseText));
        }
      }
      xhr.onerror = function () {
        reject({
          status: this.status,
          statusText: xhr.statusText
        });
      };
      xhr.send();
    });
  }
}